// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__8I_iS","text":"styles_text__2Ubyq"};